module.exports = __webpack_public_path__ + "static/media/team-7.a46a829b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team-7.png
// module id = 1191
// module chunks = 0